// Module
var code = `<ng-form name="\$ctrl.form">
  <div class="form-column">
    <form-section form-title="'Settlement'">
      <form-section-field field-title="'E-mail address'">
        <input
          type="email"
          ng-model="\$ctrl.agent.email"
          maxlength="64"/>
      </form-section-field>
      <form-section-field field-title="'Deposit account for transactions'">
        <account-select ng-required="true"
                        query-field="'id'"
                        value-field="'id'"
                        field-mapping="{accountGroup: null, accountGroupMaxLength: null, name: 'name'}"
                        options="\$ctrl.accounts"
                        ng-model="\$ctrl.selectedAccount"
                        ng-change="\$ctrl.accountChanged()">
        </account-select>
    </form-section>
  </div>

  <div class="clearfix"></div>
</ng-form>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/agent-banking/details/settlement/agents-settlement.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;